import PropTypes from 'prop-types';
import React, { useState } from 'react';

import { Button } from 'common-src/components/base';
import { ColorsNew } from 'common-src/styles';

import useAlert from 'src/hooks/useAlert';

import styles from './Appointments.module.scss';
import { pushAppointmentsApi } from './utils';

const pushAppointments = async (patientId, portalPatientId, showAlert, AlertType, setIsLoading) => {
  setIsLoading(true);
  try {
    const result = await pushAppointmentsApi(patientId, portalPatientId);
    const { ok, data, status } = result;
    if (!ok) {
      showAlert(
        AlertType.Error,
        '',
        (data && (data.message || data.detail)) || `Request failed with status ${status}`,
      );
      return null;
    }
    const results = data?.external_api_results;
    if (Array.isArray(results) && results.length > 0) {
      const failed = results.filter((r) => r.success === false);
      if (failed.length > 0) {
        const errorDetails = failed
          .map((r) => r.response?.detail)
          .filter(Boolean)
          .join('\n');
        showAlert(AlertType.Error, '', errorDetails || 'Unknown external error.');
        return data;
      }
    }
    showAlert(AlertType.Success, '', data.message || 'Appointments pushed successfully.');
    return data;
  } catch (error) {
    showAlert(AlertType.Error, '', error.message || 'Unknown error.');
    return null;
  } finally {
    setIsLoading(false);
  }
};

const Appointments = ({ patientId, portalPatientId }) => {
  const { showAlert, AlertType } = useAlert();
  const [isLoading, setIsLoading] = useState(false);
  return (
    <div>
      <span className={styles.title}>Push Appointments to Patient Portal</span>
      <Button
        id="push-appointments-button"
        text="Push Appointments"
        backgroundColor={ColorsNew.darkGreen}
        textColor={ColorsNew.white}
        classNames={[styles.button]}
        isLoading={isLoading}
        onClick={() =>
          pushAppointments(patientId, portalPatientId, showAlert, AlertType, setIsLoading)
        }
      />
    </div>
  );
};

Appointments.propTypes = {
  portalPatientId: PropTypes.string.isRequired,
  patientId: PropTypes.number.isRequired,
};

export default Appointments;
